import { useEffect } from 'react';
import { loadImageHref } from '../../branding/favicon';

/** A canonical preview owns only its document's icon and restores it when leaving/changing drafts. */
export function useSurveyFavicon(url?: string) {
  useEffect(() => {
    let cancelled = false;
    let restore: (() => void) | undefined;
    void loadImageHref(url).then((href) => {
      if (cancelled || !href) return;
      const existing = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
      const link = existing ?? document.createElement('link');
      const previous = link.getAttribute('href');
      link.rel = 'icon';
      link.href = href;
      if (!existing) document.head.appendChild(link);
      restore = () => {
        // Another metadata owner may have replaced this icon since our effect ran.
        if (link.href !== href) return;
        if (!existing) link.remove();
        else if (previous === null) link.removeAttribute('href');
        else link.setAttribute('href', previous);
      };
    });
    return () => {
      cancelled = true;
      restore?.();
    };
  }, [url]);
}
